
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoaderIcon from '../Icons/LoaderIcon';

const propTypes = {
  show: PropTypes.bool,
};

const LoadingSpinner = ({ show = false }) => {
  const componentClassName = classNames('ee_loading-spinner', {
    'ee_loading-spinner--hide': !show,
  });

  return (
    <div className={componentClassName}>
      <LoaderIcon
        title="Lädt..."
        width={50}
        height={50}
        spinning
        className="ee_loading-spinner__icon"
      />
    </div>
  );
};

LoadingSpinner.propTypes = propTypes;

export default LoadingSpinner;

